// mediaCampaignId and storeGroups are now the canonical backend field names
// used directly in campaign state, so no stripping or mapping is needed.

export const stripUnmappedB2b2cFieldsFromPayload = (campaignObject = {}) => {
  return { ...campaignObject };
};

export const hydrateB2b2cStateFromLoadedCampaign = (campaignData = {}) => {
  return campaignData;
};
